// Generated by scripts/build-ui-icons.mjs.
export { Buildings as default } from "../ui/glyphs-1";
